import { loader } from 'graphql.macro';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';

import { CompanyTypeConnection, ChangePageArgs } from '../definitions.d';
import { PAGE_SIZE } from '../config/constants';
import { getFetchMoreVariables } from '../utils/utils';
import useHandleError from './useHandleError';

const COMPANIES_PAGED = loader('../graphql/companiesPaged.graphql');

interface CompaniesQueryResponse {
  companiesPaged: CompanyTypeConnection;
  loading?: boolean;
  error?: Error;
  fetchMore: (values: ChangePageArgs | null) => void;
}

const useCompaniesPagedQuery = (
  searchTerm: string | null = null
): CompaniesQueryResponse => {
  const { handleError } = useHandleError();

  const { data, loading, error, fetchMore } = useQuery(COMPANIES_PAGED, {
    variables: { first: PAGE_SIZE, search: searchTerm },
    onError: (e) => {
      handleError(e);
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });

  return {
    companiesPaged: get(data, 'companiesPaged'),
    loading,
    error,
    fetchMore: (values: ChangePageArgs | null) => {
      fetchMore({
        variables: getFetchMoreVariables(values),
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }
          return fetchMoreResult;
        }
      });
    }
  };
};

export default useCompaniesPagedQuery;
